import _inject from "@stylexjs/stylex/lib/stylex-inject";
var _inject2 = _inject;
import * as stylex from "@stylexjs/stylex";
import { useQuery } from "@tanstack/react-query";
import { AlertTriangle, Clock, RefreshCw } from "lucide-react";
import { motion } from "motion/react";
import { Button } from "@/components/button";
import { formatWeekendRange } from "@/core/guild-war/weekend-dates";
import { absenceTrackingApi } from "@/lib/absence-tracking-api";
import { guildWarApi } from "@/lib/guild-war-api";
import { guildWarKeys } from "@/lib/query-keys";
import { BlurFade } from "../ui/blur-fade";
_inject2({
  ltr: "@keyframes x13kz0yu-B{0%, 100%{opacity:1;}50%{opacity:.5;}}",
  priority: 0
});
const pulse = "x13kz0yu-B";
_inject2({
  ltr: ".x78zum5{display:flex}",
  priority: 3000
});
_inject2({
  ltr: ".x6s0dn4{align-items:center}",
  priority: 3000
});
_inject2({
  ltr: ".x13z6uf9{gap:.5rem}",
  priority: 2000
});
_inject2({
  ltr: ".x116uinm{border-radius:.5rem}",
  priority: 2000
});
_inject2({
  ltr: ".xmkeg23{border-width:1px}",
  priority: 2000
});
_inject2({
  ltr: ".x1y0btm7{border-style:solid}",
  priority: 2000
});
_inject2({
  ltr: ".xzzvqgh{border-color:color-mix(in oklab,var(--danger) 30%,transparent)}",
  priority: 2000
});
_inject2({
  ltr: ".x11sw5dc{background-color:color-mix(in oklab,var(--danger) 10%,transparent)}",
  priority: 3000
});
_inject2({
  ltr: ".x13eudtd{padding-block:.625rem}",
  priority: 2000
});
_inject2({
  ltr: ".xnxx81d{padding-inline:1rem}",
  priority: 2000
});
_inject2({
  ltr: ".xkpwil5{font-size:.875rem}",
  priority: 3000
});
_inject2({
  ltr: ".x8r4c90{line-height:1.25rem}",
  priority: 3000
});
_inject2({
  ltr: ".x1sr8853{color:var(--danger)}",
  priority: 3000
});
_inject2({
  ltr: ".xcdlrvm{width:1rem}",
  priority: 4000
});
_inject2({
  ltr: ".x1l36t39{height:1rem}",
  priority: 4000
});
_inject2({
  ltr: ".x2lah0s{flex-shrink:0}",
  priority: 3000
});
_inject2({
  ltr: ".x1xvt488{width:.875rem}",
  priority: 4000
});
_inject2({
  ltr: ".xf08kfj{height:.875rem}",
  priority: 4000
});
_inject2({
  ltr: ".x1jw3ynk{width:.75rem}",
  priority: 4000
});
_inject2({
  ltr: ".xvle69y{height:.75rem}",
  priority: 4000
});
_inject2({
  ltr: ".x8x9d4c{margin-left:auto}",
  priority: 4000
});
_inject2({
  ltr: ".xrvj5dj{display:grid}",
  priority: 3000
});
_inject2({
  ltr: ".x8233eu{gap:.75rem}",
  priority: 2000
});
_inject2({
  ltr: ".x1r5q1ko{border-color:color-mix(in oklab,var(--warning) 30%,transparent)}",
  priority: 2000
});
_inject2({
  ltr: ".x1fhmphn{background-color:color-mix(in oklab,var(--warning) 10%,transparent)}",
  priority: 3000
});
_inject2({
  ltr: ".xcly8g5{color:var(--warning)}",
  priority: 3000
});
_inject2({
  ltr: ".x1ljrhy{border-color:color-mix(in oklab,var(--info) 30%,transparent)}",
  priority: 2000
});
_inject2({
  ltr: ".xw3fxqz{background-color:color-mix(in oklab,var(--info) 10%,transparent)}",
  priority: 3000
});
_inject2({
  ltr: ".x1d4anm9{color:var(--info)}",
  priority: 3000
});
_inject2({
  ltr: ".x1mec67s{border-radius:1.1rem}",
  priority: 2000
});
_inject2({
  ltr: ".x1x06y58{border-color:var(--surface-border)}",
  priority: 2000
});
_inject2({
  ltr: ".xp9zp6x{background-color:color-mix(in oklch,var(--surface-2) 94%,var(--secondary))}",
  priority: 3000
});
_inject2({
  ltr: ".x1uz70x1{padding:1rem}",
  priority: 1000
});
_inject2({
  ltr: ".xrvchh{color:var(--muted-foreground)}",
  priority: 3000
});
_inject2({
  ltr: ".x1iuv88s{font-size:.72rem}",
  priority: 3000
});
_inject2({
  ltr: ".x1xlr1w8{font-weight:700}",
  priority: 3000
});
_inject2({
  ltr: ".x1labic3{letter-spacing:.14em}",
  priority: 3000
});
_inject2({
  ltr: ".xtvhhri{text-transform:uppercase}",
  priority: 3000
});
_inject2({
  ltr: ".xdt5uv0{margin-top:.4rem}",
  priority: 4000
});
_inject2({
  ltr: ".xzwc6uz{font-family:\"Cormorant Garamond\",Georgia,serif}",
  priority: 3000
});
_inject2({
  ltr: ".xnzeo4v{font-size:clamp(1.7rem,3vw,2.4rem)}",
  priority: 3000
});
_inject2({
  ltr: ".x1s688f{font-weight:600}",
  priority: 3000
});
_inject2({
  ltr: ".xo5v014{line-height:1}",
  priority: 3000
});
_inject2({
  ltr: ".xb3r6kr{overflow:hidden}",
  priority: 2000
});
_inject2({
  ltr: ".xlyipyv{text-overflow:ellipsis}",
  priority: 3000
});
_inject2({
  ltr: ".xuxw1ft{white-space:nowrap}",
  priority: 3000
});
_inject2({
  ltr: ".x1rg5ohu{display:inline-block}",
  priority: 3000
});
_inject2({
  ltr: ".xekueh{width:4rem}",
  priority: 4000
});
_inject2({
  ltr: ".x16eypsj{border-radius:.25rem}",
  priority: 2000
});
_inject2({
  ltr: ".xuhz2es{background-color:var(--muted)}",
  priority: 3000
});
_inject2({
  ltr: ".xcx56e2{animation-name:x13kz0yu-B}",
  priority: 3000
});
_inject2({
  ltr: ".x1c74tu6{animation-duration:2s}",
  priority: 3000
});
_inject2({
  ltr: ".xw1l40g{animation-timing-function:cubic-bezier(.4,0,.6,1)}",
  priority: 3000
});
_inject2({
  ltr: ".xa4qsjk{animation-iteration-count:infinite}",
  priority: 3000
});
_inject2({
  ltr: ".xam5rvr{height:1.5rem}",
  priority: 4000
});
_inject2({
  ltr: ".xex909m{width:5rem}",
  priority: 4000
});
_inject2({
  ltr: ".x1orek7e{color:var(--destructive)}",
  priority: 3000
});
_inject2({
  ltr: ".x5j7nwy{margin-top:.375rem}",
  priority: 4000
});
_inject2({
  ltr: ".xb8l8e1{height:1.75rem}",
  priority: 4000
});
_inject2({
  ltr: ".xboafo0{font-size:.75rem}",
  priority: 3000
});
_inject2({
  ltr: ".xl2ypbo{line-height:1rem}",
  priority: 3000
});
_inject2({
  ltr: ".x16yd4ao{color:var(--success)}",
  priority: 3000
});
_inject2({
  ltr: ".x1tbvfm1{margin-top:.25rem}",
  priority: 4000
});
_inject2({
  ltr: ".x1eo1nwe{color:color-mix(in oklab,var(--muted-foreground) 70%,transparent)}",
  priority: 3000
});
const styles = {
  retryAtEnd: {
    koQZXg: "x8x9d4c",
    kmuXW: "x2lah0s",
    $$css: true
  },
  alert: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x8233eu",
    kaIpWk: "x116uinm",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kg3NbH: "xnxx81d",
    k8WAf4: "x13eudtd",
    kGuDYH: "xkpwil5",
    kLWn49: "x8r4c90",
    $$css: true
  },
  warning: {
    kVAM5u: "x1r5q1ko",
    kWkggS: "x1fhmphn",
    kMwMTN: "xcly8g5",
    $$css: true
  },
  info: {
    kVAM5u: "x1ljrhy",
    kWkggS: "xw3fxqz",
    kMwMTN: "x1d4anm9",
    $$css: true
  },
  danger: {
    kVAM5u: "xzzvqgh",
    kWkggS: "x11sw5dc",
    kMwMTN: "x1sr8853",
    $$css: true
  },
  metricValue: {
    keoZOQ: "xdt5uv0",
    kMv6JI: "xzwc6uz",
    kGuDYH: "xnzeo4v",
    k63SB2: "x1s688f",
    kLWn49: "xo5v014",
    $$css: true
  },
  truncate: {
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  compactRetry: {
    keoZOQ: "x5j7nwy",
    kZKoxP: "xb8l8e1",
    kGuDYH: "xboafo0",
    kLWn49: "xl2ypbo",
    $$css: true
  },
  successValue: {
    kMwMTN: "x16yd4ao",
    $$css: true
  },
  warningValue: {
    kMwMTN: "xcly8g5",
    $$css: true
  },
  mutedValue: {
    kMwMTN: "xrvchh",
    $$css: true
  }
};
export function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}
interface Alert {
  id: string;
  message: string;
  variant: "warning" | "info" | "danger";
  icon: React.ReactNode;
}
const alertStyles: Record<Alert["variant"], stylex.StyleXStyles> = {
  warning: styles.warning,
  info: styles.info,
  danger: styles.danger
};
function useDashboardQuery() {
  return useQuery({
    queryKey: guildWarKeys.meDashboard(),
    queryFn: () => guildWarApi.getMyDashboard(),
    staleTime: 30_000
  });
}
export function DashboardAlerts() {
  const dashboardQuery = useDashboardQuery();
  const dashboard = dashboardQuery.data;
  const alerts: Alert[] = [];
  if (dashboardQuery.isLoading) return null;
  if (dashboardQuery.isError) {
    return <div className="x78zum5 x6s0dn4 x13z6uf9 x116uinm xmkeg23 x1y0btm7 xzzvqgh x11sw5dc x13eudtd xnxx81d xkpwil5 x8r4c90 x1sr8853" role="alert" aria-live="assertive">
        <AlertTriangle className="xcdlrvm x1l36t39 x2lah0s" />
        <span>Failed to load guild war status.</span>
        <Button variant="outline" size="sm" stylexStyle={styles.retryAtEnd} onClick={() => void dashboardQuery.refetch()}>
          <RefreshCw className="x1xvt488 xf08kfj" />
          Retry
        </Button>
      </div>;
  }
  if (!dashboard?.week) return null;
  const weekState = dashboard.week.state;
  const weekStart = new Date(dashboard.week.weekStartAt);
  const hasActiveSignup = dashboard.weeklySignup?.state === "active";
  if (weekState === "signup_open") {
    const daysUntil = Math.ceil((weekStart.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
    if (daysUntil <= 3 && daysUntil > 0) {
      alerts.push({
        id: "signup-closing",
        message: `Guild War signups close in ${daysUntil} day${daysUntil === 1 ? "" : "s"}`,
        variant: "warning",
        icon: <Clock className="xcdlrvm x1l36t39 x2lah0s" />
      });
    }
    if (!hasActiveSignup && !dashboard.isPermanentMember && !dashboard.pendingPermanentApplication) {
      alerts.push({
        id: "no-signup",
        message: "Guild War signups are open — ready to join this week?",
        variant: "warning",
        icon: <AlertTriangle className="xcdlrvm x1l36t39 x2lah0s" />
      });
    }
  }
  if (alerts.length === 0) return null;
  return <div className="xrvj5dj x13z6uf9">
      {alerts.map((alert, i) => <BlurFade key={alert.id} delay={0.1 + i * 0.05} duration={0.25} offset={4} blur="4px">
          <motion.div {...stylex.props(styles.alert, alertStyles[alert.variant])} initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.1 + i * 0.05
      }}>
            {alert.icon}
            <span>{alert.message}</span>
          </motion.div>
        </BlurFade>)}
    </div>;
}
type Stat = {
  label: string;
  value: string;
  detail?: string;
  tone?: "success" | "warning" | "muted";
};
const toneStyles: Record<NonNullable<Stat["tone"]>, stylex.StyleXStyles> = {
  success: styles.successValue,
  warning: styles.warningValue,
  muted: styles.mutedValue
};
export function DashboardQuickStats() {
  const dashboardQuery = useDashboardQuery();
  const absenceQuery = useQuery({
    queryKey: ["absence-tracking", "my-dashboard"],
    queryFn: () => absenceTrackingApi.getMyDashboard(),
    staleTime: 30_000
  });
  const isLoading = dashboardQuery.isLoading || absenceQuery.isLoading;
  if (isLoading) {
    return <>
        {Array.from({
        length: 3
      }).map((_, i) => <div key={i} className="x1mec67s xmkeg23 x1y0btm7 x1x06y58 xp9zp6x x1uz70x1">
            <div className="xrvchh x1iuv88s x1xlr1w8 x1labic3 xtvhhri">
              <span className="x1rg5ohu xvle69y xekueh x16eypsj xuhz2es xcx56e2 x1c74tu6 xw1l40g xa4qsjk" />
            </div>
            <div className="xdt5uv0 xzwc6uz xnzeo4v x1s688f xo5v014">
              <span className="x1rg5ohu xam5rvr xex909m x16eypsj xuhz2es xcx56e2 x1c74tu6 xw1l40g xa4qsjk" />
            </div>
          </div>)}
      </>;
  }
  const dashboard = dashboardQuery.data;
  const absences = absenceQuery.data;
  if (dashboardQuery.isError || absenceQuery.isError) {
    const failedQueries: string[] = [];
    if (dashboardQuery.isError) failedQueries.push("guild war");
    if (absenceQuery.isError) failedQueries.push("absence");
    return <div className="x1mec67s xmkeg23 x1y0btm7 x1x06y58 xp9zp6x x1uz70x1" role="alert" aria-live="assertive">
        <div className="xrvchh x1iuv88s x1xlr1w8 x1labic3 xtvhhri">Error</div>
        <div className="xdt5uv0 xzwc6uz xnzeo4v x1s688f xo5v014 xb3r6kr xlyipyv xuxw1ft x1orek7e">
          Failed to load {failedQueries.join(" & ")} data
        </div>
        <Button variant="outline" size="sm" stylexStyle={styles.compactRetry} onClick={() => {
        void dashboardQuery.refetch();
        void absenceQuery.refetch();
      }}>
          <RefreshCw className="x1jw3ynk xvle69y" />
          Retry
        </Button>
      </div>;
  }
  const hasActiveSignup = dashboard?.weeklySignup?.state === "active";
  const stats: Stat[] = [];
  if (dashboard?.week) {
    const weekState = dashboard.week.state;
    const weekLabel = formatWeekendRange({
      weekStartAt: dashboard.week.weekStartAt
    });
    if (weekState === "signup_open") stats.push({
      label: "Guild War Week",
      value: "Signups Open",
      detail: weekLabel
    });else if (weekState === "planning") stats.push({
      label: "Guild War Week",
      value: "Planning",
      detail: weekLabel
    });else if (weekState === "draft") stats.push({
      label: "Guild War Week",
      value: "Draft",
      detail: weekLabel
    });else stats.push({
      label: "Guild War Week",
      value: "Completed",
      detail: weekLabel
    });
  } else {
    stats.push({
      label: "Guild War Week",
      value: "No Active Week"
    });
  }
  if (dashboard?.isPermanentMember) {
    stats.push({
      label: "Guild War",
      value: "Permanent Member",
      detail: "Auto-included each week",
      tone: "success"
    });
  } else if (dashboard?.pendingPermanentApplication) {
    stats.push({
      label: "Guild War",
      value: "Application Pending",
      detail: "Awaiting admin review",
      tone: "warning"
    });
  } else if (hasActiveSignup) {
    const availability = dashboard!.weeklySignup!.availability;
    const availLabel = availability === "both" ? "Sat & Sun" : availability === "saturday" ? "Saturday" : "Sunday";
    stats.push({
      label: "Guild War",
      value: "Submitted",
      detail: availLabel,
      tone: "success"
    });
  } else if (dashboard?.week?.state === "signup_open") {
    stats.push({
      label: "Guild War",
      value: "Not Submitted",
      tone: "warning"
    });
  } else if (dashboard?.week) {
    stats.push({
      label: "Guild War",
      value: "Not Submitted",
      tone: "muted"
    });
  } else {
    stats.push({
      label: "Guild War",
      value: "No Active Week",
      tone: "muted"
    });
  }
  if (absences) {
    const pendingCount = absences.activeItems.filter(a => a.state === "pending").length;
    const approvedCount = absences.activeItems.filter(a => a.state === "approved").length;
    if (pendingCount > 0) {
      stats.push({
        label: "Absences",
        value: `${pendingCount} Pending`,
        detail: approvedCount > 0 ? `${approvedCount} active` : undefined
      });
    } else if (approvedCount > 0) {
      stats.push({
        label: "Absences",
        value: `${approvedCount} Active`
      });
    } else {
      stats.push({
        label: "Absences",
        value: "None"
      });
    }
  }
  return <>
      {stats.map(stat => <div key={stat.label} className="x1mec67s xmkeg23 x1y0btm7 x1x06y58 xp9zp6x x1uz70x1">
          <div className="xrvchh x1iuv88s x1xlr1w8 x1labic3 xtvhhri">{stat.label}</div>
          <div {...stylex.props(styles.metricValue, styles.truncate, stat.tone && toneStyles[stat.tone])}>
            {stat.value}
          </div>
          {stat.detail && <div className="x1tbvfm1 xb3r6kr xlyipyv xuxw1ft xboafo0 xl2ypbo x1eo1nwe">{stat.detail}</div>}
        </div>)}
    </>;
}